<template>
  <div v-if="this.showDashboard()" class="dashboard-container">
    <div class="child-container">
      <div class="grid-container">
        <div class="grid">
          <div class="graph">
            <div class="block"><CurrentProjectGraphv2 ref="currentProjectStatusGraph" /></div>
          </div>
          <div class="graph">
            <div class="block"><DueDateGraphv2  ref="DueDatePerformanceGraph" /></div>
          </div>
          <div class="graph">
            <div class="block"><DueDateGraphDaysv2 ref="DueDatePerformanceDaysGraph" /></div>
          </div>
          <div class="graph">
            <div class="block"><EfficiencyGraphv2 ref="efficiencyGraph" /></div>
          </div>
          <div class="graph">
            <div class="block"><FinancialGraphv2 ref="financialsGraph" /></div>
          </div>
          <div class="graph">
            <div class="block"><ProjectsFinished ref="projectsFinished" /></div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container">
      <div class="slider-container">
        <div class="hour-index">
          Day {{ Math.floor(this.slider / 8) }} Hour
          {{ 8 * ((this.slider / 8) % 1) }}
        </div>
        <input id="indexslider" type="range" min="0" :max="this.$store.state.simulator.performanceTracker.metrics.length - 1" @input="(v) => updateIndex(v)" :value="this.slider" class="indexslider" />
      </div>
    </div>
  </div>
  <div v-else  class="noGraphs">

  <div class="nographText">No simulation is loaded, go to the pipeline page first</div>
  </div>
</template>

<script>
import CurrentProjectGraphv2 from '@/components/dashboard/CurrentProjectGraphv2.vue';
import DueDateGraphv2 from '@/components/dashboard/DueDateGraphv2.vue';
import DueDateGraphDaysv2 from '@/components/dashboard/DueDateDaysGraphv2.vue';
import FinancialGraphv2 from '@/components/dashboard/FinancialGraphv2.vue';
import EfficiencyGraphv2 from '@/components/dashboard/EfficiencyGraphv2.vue';
import ProjectsFinished from '@/components/dashboard/ProjectsFinished.vue';

export default {
  components: {  FinancialGraphv2,CurrentProjectGraphv2, EfficiencyGraphv2, DueDateGraphv2, DueDateGraphDaysv2, ProjectsFinished},
  props: {},
  data: () => ({
    slider: 0,
  }),
  setup() {},
  beforeMount() {
    if(this.showDashboard()){
      this.slider = this.getSliderIndex();
      this.$store.state.dashboard.slider = this.slider;
      // this.$store.state.simulator.automateUntilEnd("EpicFlow", []);
    }
  },
  mounted() {
  },
  methods: {
    getSliderIndex() {
      if (this.$store.state.simulator.performanceTracker.metrics.length == 1) {
        return 0;
      }
      return this.$store.state.simulator.performanceTracker.metrics.length - 1;
    },
    showDashboard() {
      return this.$store.state.simulator != null;
    },
    updateElements() {
      this.$refs.currentProjectStatusGraph.updateChart();
      this.$refs.DueDatePerformanceGraph.updateChart();
      this.$refs.DueDatePerformanceDaysGraph.updateChart();
      this.$refs.efficiencyGraph.updateChart();
      this.$refs.financialsGraph.updateChart();
      this.$refs.projectsFinished.updateChart();
      //   this.updateDonutChart();
      //   this.updateProfitColor();
      //   this.updateCurrentDelayedColor();
      //   this.currentFlow = this.getFlowValue();
    },
    updateIndex(val) {
      this.$store.state.dashboard.slider = val.srcElement.value;
      this.slider = val.srcElement.value;
      this.updateElements();
    },
  },
};
</script>

<style scoped>
.noGraphs {
  width: 100%;
  height: 100%;
  padding: 50px;
  display: flex;
  font-size: 2em;
  font-family: Helvetica, sans-serif;
  font-weight: bold;
}

.nographText {
  width: 100%;
  height: 100%;
  text-align: center;
}
.hour-index {
  position: absolute;
  color: rgba(128, 128, 128, 1);
  top: 3px;
}

.slider-container {
  align-items: center; /* Center vertically */
  width: calc(100% - 208px);
  position: relative;
  left: 52px;
  top: 3px;
}
.icon {
  width: 38px;
  height: 38px;
}

.slider-logo-container {
  height: 100%;
  width: 90px;
  display: flex;
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
}
/* The slider itself */
.indexslider {
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  height: 25px; /* Specified height */
  background: #d3d3d3; /* Grey background */
  outline: none; /* Remove outline */
  opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
  -webkit-transition: 0.2s; /* 0.2 seconds transition on hover */
  transition: opacity 0.2s;
  margin-top: 27px;
}

/* Mouse-over effects */
.indexslider:hover {
  opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
  appearance: none;
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.indexslider::-moz-range-thumb {
  width: 25px; /* Set a specific slider handle width */
  height: 25px; /* Slider handle height */
  background: #3f51b5; /* Green background */
  cursor: pointer; /* Cursor on hover */
}

.indexslider {
  -webkit-appearance: none;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background: rgb(227, 232, 255);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  float: "right";
}

.indexslider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5;
  cursor: pointer;
}

.indexslider::-moz-range-thumb {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #3f51b5;
  cursor: pointer;
}

.child-container {
  width: 100%;
  height: 100%;
}

.dashboard-container {
  width: 100%;
  height: calc(100%);
  max-height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 940px;

  overflow-y: auto;
  overflow-x: auto;

  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 70px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%; /* Set the width to 100% */
  height: calc(100% - 20px);
  margin-bottom: 20px;
  grid-gap: 20px;
}

.projects-finished-text {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: rgba(74, 74, 74, 1);
}

.projects-finished {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
    resize: both;

}

.projects-finished-number {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans";

  font-weight: 600;
  width: 100%;
  color: rgba(110, 188, 44, 1);
}

.block {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(245, 245, 245, 1);
  /* border: 1px solid black; */
  box-sizing: border-box;
  width: calc(min(33vw - 80px, 50vh - 70px));
  aspect-ratio: 1;
  min-height: 360px;
  min-width: 360px;
  /* margin: auto; */
}

.graph {
  display: flex;
  width: 100%; /* Set width to the minimum of 80% of viewport width and 80% of viewport height */
  height: 100%; /* Set height to the minimum of 80% of viewport width and 80% of viewport height */
  justify-content: center;
  align-items: center;
}

.grid-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto; /* Enable both horizontal and vertical scrolling */
  overflow-x: auto; /* Add this line for horizontal scrolling */
  min-width: 930px;
  min-height: 650px;
}

.bottom-container {
  width: 100%;
  height: 64px;
  background-color: rgba(253, 253, 253, 1);

  border-top: 1px solid rgba(220, 220, 220, 1);
  position: fixed;
  bottom: 0;
  left: 90px;
  display: flex;
}

/* Media query for larger screens (adjust as needed) */
</style>
